module.exports = __webpack_public_path__ + "img/Quand c’est.d99dd4e8.webp";